import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Slider from "react-slick";
import FpgDeleteIcon from '../../icons/fpgdeleteicon';
import FpgeeditIcon from '../../icons/fpgediticon';
//moment import
import moment from "moment-timezone";

import service from '../../services';
import Player from 'video-react/lib/components/Player';
import PlayToggle from 'video-react/lib/components/control-bar/PlayToggle';
import ControlBar from 'video-react/lib/components/control-bar/ControlBar';
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ErrorPopUp from '../../component/errorPopUp';

let sub;
const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;
class PartnersFilmViewDetail extends Component {

    constructor(props) {
        super(props)

        this.state = {
            imagePreloader: false,
            createOpen: false,
            films: [],
            filmList: {},
            film: {},
            deleteFilm: false,
            updatedAt: ''
        }
        this.apiserve = new service();
    }
    componentWillUnmount = () => {
        sub.unsubscribe();
    }
    componentDidMount() {
        if (this.props.allInitial && this.props.allInitial.film) {
            var programData = this.props.allInitial.film.category.map(function (el) {
                let o = Object.assign({}, el);
                o.value = false;
                return o;
            });
            this.setState({
                filmList: this.props.allInitial.film,
                programArray: programData
            })
        }
        this.apiserve.sendevent("privateScreeningPartner|film|getLastUpdated", { type: 1 });
        if (this.props.match.params && this.props.match.params.id) {
            this.setState({
                filmID: this.props.match.params.id
            })
            this.apiserve.sendevent("privateScreeningPartner|film|getAllDetail", { filmId: this.props.match.params.id });
        }
        this.getData();
    }
    deleteFilm = () => {
        this.setState({
            deleteFilm: true
        })
    }

    deleteFilmPopupYes = () => {
        this.apiserve.sendevent("privateScreeningPartner|film|remove", {
            filmId: this.state.film._id
        });
    }
    closeAdminUser = () => {
        this.setState({
            deleteFilm: false,
        })
    }

    getData() {
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "privateScreeningPartner|film|getAllDetail":
                    if (!response.error) {
                        this.setState({
                            film: response.data
                        })
                    } else {
                        this.apiserve.error(response.data)
                    }
                    break;
                case "privateScreeningPartner|film|getLastUpdated":
                    if (!response.error) {
                        this.setState({
                            updatedAt: response.data.updatedAt ? moment(response.data.updatedAt).tz('US/Mountain').format('hh:mm A - MM/DD/YYYY') : '',
                            updatedBy: (response.data.updatedBy && response.data.updatedBy.fname + response.data.updatedBy.lname) || ''
                        })
                    }
                    break;
                case "privateScreeningPartner|film|remove":
                    if (!response.error) {
                        this.props.history.push('/partners-film-view')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                default:
                    break;
            }
        });
    }



    componentDidUpdate(prevProps) {
        if (prevProps.allInitial !== this.props.allInitial) {
            if (this.props.allInitial && this.props.allInitial.film) {
                var programData = this.props.allInitial.film.category.map(function (el) {
                    let o = Object.assign({}, el);
                    o.value = false;
                    return o;
                });
                this.setState({
                    filmList: this.props.allInitial.film,
                    programArray: programData
                })
            }
        }
    }

    generList = (id) => {
        var filmGenre = [] = (this.state.filmList && this.state.filmList.genre) || [];

        var names = []
        filmGenre.forEach(f => {
            if (f._id === id) {
                names.push(f.name)
            }
        });
        return names.map(name => {
            return (<p>{name}</p>)
        })
    }

    interestTrackList = (id) => {
        var filmGenre = [] = (this.state.filmList && this.state.filmList.interestTrack) || [];
        var names = []
        filmGenre.forEach(f => {
            if (f._id === id) {
                names.push(f.name)
            }
        });

        return names.map(name => {
            return (<p>{name}</p>)
        })
    }

    editFilmEvent = () => {
        if (this.state.film && this.state.film._id)
            this.props.history.push('/edit-private-film/' + this.state.film._id)
    }
    render() {
        var settings = {
            customPaging: function (i) {
                return <a>{i + 1}</a>;
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        const { film, filmList } = this.state
        var self = this;

        let profileName='';
        let data = JSON.parse(localStorage.getItem('persist:root'));
        if(data && data.profileName){
            profileName = JSON.parse(data.profileName);
        }
        return (
            <>
                <div className="right_side_wrapper">
                    {/* <ul className="fpg_admin_tab ">
                        <li className="active">
                            <p className="text_left">
                                <div className="d_flex d_flex_align_center">
                                     <Link to='/partners-profile'><span>{profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname : '654654'}</span></Link>&nbsp;&nbsp;
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z" fill="white" />
                                    </svg> &nbsp;&nbsp;
                                   <Link to='partners-film-view'><span> Films ({localStorage.getItem('filmListlength') || 0}) </span></Link> &nbsp; &nbsp; &gt;  &nbsp;&nbsp;{film.title}
                                </div>
                            </p>
                        </li>
                    </ul> */}

                    <div className="dashboard_header with_btn profile_header">
                        <div className="searchBlock mx_100">
                            <span className="d_flex d_flex_align_center"> <Link to='/partners-profile' ><span>
                                {profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname: ''}</span> </Link> &nbsp;&nbsp;
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z" fill="white" />
                                </svg> &nbsp;&nbsp;
                                <Link to='/partners-film-view'><span> Films ({localStorage.getItem('filmListlength') || 0}) </span></Link> &nbsp; &nbsp; &gt;  &nbsp;&nbsp;{film.title}
                            </span>
                        </div>
                        <div className="button_block admin_user_twoBtn">
                            {/* <span className="head_btn pointer" onClick={this.CreatePartner}> Add Film + </span> */}
                        </div>
                    </div>

                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <Link className="back_link" to='/partners-film-view'>
                            <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg> Back To List
                        </Link>
                        <p className="update_date">Last Update: {this.state.updatedAt}</p>
                    </div>
                    <div className="fpg_tabcontent d_flex">
                        <div className="tab_col left_col">
                            <div className="d_flex id_media d_flex_align_center">
                                <span className="id_text w_100 d_flex">
                                    <label>Media ID:</label>
                                    <p>{film.mediaId}</p>
                                </span>
                                <span className="id_text d_flex">
                                    <label>Filemaker ID:</label>
                                    <p>{film.fileMakerId}</p>
                                </span>
                                {/* <span className="id_text d_flex">
                                    <label>Shift72 ID:</label>
                                    <p>{film.shift72Id}</p>
                                </span> */}
                                {console.log(film)}
                                <span className="id_text d_flex">
                                    <label>Eventive ID:</label>
                                    <p>{film.eventiveId}</p>
                                </span>
                            </div>
                            {/* <Slider {...settings}>

                                {film && film.images && film.images.length &&
                                    film.images.map((item, index) => {
                                        return (
                                            <div>
                                                {EXT_IMAGES.test(item.inSite) ? (
                                                    <React.Fragment>
                                                        <div className="media_image mb_0 absolute_loader relative">
                                                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? item.link: '/images/image-placeholder.png'} alt="image"/>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                                    :
                                                    EXT_VIDEO.test(item.inSite || item.link) ?  (
                                                        <React.Fragment>
                                                            <div className="form_group common_video_upload">
                                                                <div className="form_group_inner">
                                                                    <label className="font_500 mb_5">Header Video</label>
                                                                    <div className="form_group_video loader-main">
                                                                        <div className="form_group_video_wpr">
                                                                            (
                                                                            <>
                                                                                <Player
                                                                                    playsInline
                                                                                    autoPlay={false}
                                                                                    type="video/mp4"
                                                                                    // src={this.apiserve.imageUrl +  this.state.homeVideo}
                                                                                    src={item.inSite ? self.apiserve.imageUrl + item.inSite : item.link ? item.link : '/images/image-placeholder.png'}
                                                                                >
                                                                                    <ControlBar autoHide={false} disableDefaultControls={true}>
                                                                                        <PlayToggle />
                                                                                    </ControlBar>
                                                                                </Player>
                                                                            </>
                                                            )
                                                          </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    ) :  <img src={'/images/image-placeholder.png'} alt="image"/>
                                                }
                                            </div>
                                        )
                                    })}
                            </Slider> */}

                            <Slider {...settings}>
                                {film && film.images && film.images.length > 0 &&
                                    film.images.map((item) => (
                                        <div>
                                            <div className="media_image">
                                                <img
                                                    src={
                                                        item.inSite ? this.apiserve.imageUrl + item.inSite :
                                                            item.link ? item.link :
                                                                '/images/image-placeholder.png'
                                                    }
                                                    alt="image"
                                                />
                                            </div>
                                        </div>
                                    ))}
                            </Slider>
                            <div className="credit_section mt_15">
                                <div className="credit_header">
                                    <h5>Credits</h5>
                                </div>
                                <div className="credit_content">
                                    <ul>
                                        <li className="d_flex">
                                            {film.credits &&
                                                film.credits.map((item) => (
                                                    <>
                                                        <label>{item && item.creditId && item.creditId.name}</label>
                                                        <span className="name">
                                                            {item.creditType &&
                                                                item.creditType.map((creditTypeName) => (
                                                                    <p>{creditTypeName.creditsInsideType}</p>
                                                                ))}
                                                        </span>
                                                    </>
                                                ))}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="tab_col feature_col">
                            <div className="fpg_edits_links d_flex d_flex_align_center">
                                <Link className="d_flex d_flex_align_center d_flex_justify_center"
                                    onClick={this.editFilmEvent}
                                >
                                    <FpgeeditIcon />
                              EDIT
                        </Link>
                                <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()}>
                                    <FpgDeleteIcon />
                            DELETE
                        </Link>
                            </div>
                            <div className="id_text mt_5 mb_10">
                                <li className="d_flex">
                                    <label>Access: </label>
                                    <span>&nbsp;{film.access && film.access.name} </span>
                                </li>

                            </div>
                            <p className="feature_text"></p>
                            <div className="feature_title">
                                <h3></h3>
                                {/* <div className="editor_view" dangerouslySetInnerHTML={{__html: this.state.description}} /> */}
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600"> Long Description</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: film.description }} />
                            </div>
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label>Year</label>
                                        <span>{film.year}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Category</label>
                                        <span>{film.category && film.category.name}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Country</label>
                                        <span>{film.country}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Run Time</label>
                                        <span>{film.runTime}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Company</label>
                                        <span>{film.company}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Website</label>
                                        <span>{film.website}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Genre</label>
                                        <span> {film.genre && film.genre.map(e => {
                                            return this.generList(e._id)
                                        })}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Interest Tracks</label>
                                        <span> {film.interestTrack && film.interestTrack.map(e => {
                                            return this.interestTrackList(e._id)
                                        })}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Accessibility</label>
                                        <span>{film.accessibility && film.accessibility.map(e => {
                                            return <p>{e.name}</p>
                                        })}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Contact</label>
                                        <span>
                                            <p>{film.contact &&
                                                film.contact.map((item) => <p>{item && item.emailPhone}</p>)}</p>
                                        </span>
                                    </li>
                                </ul>
                                <ul>
                                    {/* <li className="d_flex">
                                        <label>Audio Description</label>
                                        <span>
                                            <span>{film.isAudioDescription ? 'Yes' : 'No'}</span>
                                        </span>
                                    </li> */}
                                    {/* <li className="d_flex">
                                        <label>Shift72 ID: </label>
                                        <span>
                                            <p>{film.audioDescriptionShift72Id}</p>
                                        </span>
                                    </li> */}
                                    <li className="d_flex">
                                        <label>Explicit Content</label>
                                        <span>
                                            <span>{film.isExplicitContent ? 'Yes' : 'No'}</span>
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label>Explicit Content Disclaimer</label>
                                        <span>
                                            <div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: film.explicitContent }} ></div>
                                        </span>
                                    </li>
                                    {/* <li className="d_flex">
                                        <label>QA Link</label>
                                        <span>{film.qaReplayLink}
                                        </span>
                                    </li> */}
                                    <li className="d_flex">
                                        <label>Screening More Info Title</label>
                                        <span>{film.screeningMoreInfoTitle}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label>Screening More Info</label>
                                        <div className="right_editor">
                                            <div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: film.screeningMoreInfo }} ></div>
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
                {this.state.deleteFilm ?
                    <PopUpCustomAll
                        HeaderName='Delete?'
                        insideDetails='You are about to delete an item and this action is permanent'
                        insideData='Do you want to proceed?'
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteFilmPopupYes}
                    />
                    : ''}

                    {this.state.errorPopup ?
                        <ErrorPopUp errorMsg ={this.state.errorMsg} errorMsgPopup={()=>{this.setState({errorPopup: false , deleteFilm: false})}}/> : ''
                    }
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    allInitial: state.allInitial,
});

export default connect(mapStateToProps)(PartnersFilmViewDetail);
